import { useCallback, useState } from 'react';

export const useVideoDurationState = ({
  logger,
  handleUsage,
  defaultMinVideoDuration = null,
  defaultMaxVideoDuration = null,
}) => {
  const [minDurationFilter, setMinDurationFilter] = useState(defaultMinVideoDuration);
  const [maxDurationFilter, setMaxDurationFilter] = useState(defaultMaxVideoDuration);

  const onVideoDurationFilterChange = useCallback(({ newMinDuration, newMaxDuration }) => {
    if (newMinDuration !== minDurationFilter) {
      logger.logTrace('onVideoDurationFilterChange', { minDuration: newMinDuration });
      setMinDurationFilter(newMinDuration);
      if (handleUsage) {
        handleUsage();
      }
    }
    if (newMaxDuration !== maxDurationFilter) {
      logger.logTrace('onVideoDurationFilterChange', { maxDuration: newMaxDuration });
      setMaxDurationFilter(newMaxDuration);
      if (handleUsage) {
        handleUsage();
      }
    }
  }, [handleUsage, logger, maxDurationFilter, minDurationFilter]);

  return {
    minDurationFilter,
    maxDurationFilter,
    onVideoDurationFilterChange,
  };
};
